export function groupByKey<T, K extends keyof T>(array: T[], key: K): Record<string, T[]> {
  return array.reduce(function (r, a) {
    r[a[key]] = r[a[key]] || [];
    r[a[key]].push(a);
    return r;
  }, Object.create(null));
}
